import React from 'react';
import { fruits } from '../data/fruits';
import FruitCard from '../components/FruitCard';
import './HomePage.css';

const HomePage = () => {
  return (
    <div className="home-page">
      <section className="welcome-section">
        <h1>欢迎来到 每日一果</h1>
        <p>在这里，发现水果的奇妙健康力量。</p>
      </section>

      <section className="popular-fruits">
        <h2>热门水果推荐</h2>
        <div className="fruit-grid">
          {fruits.map(fruit => (
            <FruitCard key={fruit.id} fruit={fruit} />
          ))}
        </div>
      </section>
    </div>
  );
};

export default HomePage;
